<template>
  <div>
    <SelectItems
      label="name"
      v-model="internalFields.value"
      :items="items"
      :loading="loading"
      :placeholder="placeholder"
      :disabled="disabled"
      :reduceFunction="(shopkeeper) => shopkeeper[propValueName]"
      :multiple="multiple"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SelectItems from './SelectItems.vue';

export default {
  name: 'SelectShopkeeperWithApp',
  model: {
    prop: 'value',
    event: 'update:value',
  },
  props: {
    value: {
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Selecione os lojistas',
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    multiple: {
      type: Boolean,
      default: true,
      required: false,
    },
    propValueName: {
      type: String,
      default: 'id',
    },
  },
  data() {
    return {
      items: [],
      internalFields: {
        value: '',
      },
    };
  },
  watch: {
    'internalFields.value': function () {
      this.$emit('update:value', this.internalFields.value);
    },
    value() {
      this.internalFields.value = this.value;
    },
  },
  created() {
    this.internalFields.value = this.value;

    if (!this.internalFields.value) {
      this.internalFields.value = this.multiple ? [] : '';
    }

    this.get();
  },
  methods: {
    ...mapActions('admin', ['getShopkeeperWithApps']),
    async get() {
      const response = await this.getShopkeeperWithApps();

      this.items = response.data || [];
    },
  },
  components: {
    SelectItems,
  },
};
</script>